<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>我们的使命</h1>
                        <span>使英语写作变得更加轻松</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="who_we_are_sections">
        <div class="container">
            <div class="row column_reverse">
                <div class="col-lg-8">
                    <div class="whot_we_are_content about_us_dots">
                        <h2>关于我们</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka AI是专为学术和技术写作而设计的下一代语法校正和语言增强写作助手。开发团队由渴望创造一个无障碍交流的未来的语言学家、工程师和数据科学家组成。我们的团队构建了写作助手来支持人们进行各种交流——从个人到学术再到日常对话。</p>
                        <p>Trinka AI 由英论阁提供技术支持。 英论阁是Crimson Interactive集团的一部分，该集团是一家拥有15年全球经验的跨国公司。Crimson在125多个国家开展业务，拥有20万多个客户、600多名员工，并且雇用5000多名专家，并在北京、东京、首尔、新泽西、伦敦等地设有
                            10 个国际办事处。</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="assets/images/whoWeAre_aboutus.png" alt="">
                    </div>
                </div>
            </div>

            <div class="row column_reverse prodcutName_sections">
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="assets/images/TrinkaD'Cunha.jpg" alt="">
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="whot_we_are_content">
                        <h2>名字背后的故事</h2>
                        <div class="HeadingSubLine"></div>
                        <p>我们相信和尊重灵感、奉献精神和远见卓识，因此以首席语言学家Trinka D'Cunha的名字命名这个最新产品。她从第一天起就一直负责该项目，直到它成为现实，以她名字命名这个工具是很有意义的。在Trinka的说明下，我们朝着消除语言障碍的使命迈出了一大步。</p>
                        <p>在设计这个先进的语言和语法修订工具时，我们由目标一致的个人所组成的团队至关重要。我们的创新产品证明了多年来的奉献精神和创造性合作。如果不是每个成员的专业知识和决心，Trinka就不可能成为现实。</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- <div class="make_in_india_section">
        <div class="made_in_india_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="made_in_india_content">
                        <h2>印度制造</h2>
                        <div class="HeadingSubLine"></div>
                        <p>我们想让印度具有更大的影响力！印度以其在信息技术领域的快速增长而闻名，已成为全球顶级的IT中心之一。</p>
                        <p>尽管印度继续快速增长，但很少有印度IT产品能够在全球大众市场上崭露头角——我们决心改变这一状况。Trinka在印度构想和设计，我们相信它必将在人工智能和自然语言处理的动态世界中留下持久的烙印。</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="made_in_india_img">
                        <img src="assets/images/madeInIndia.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="about_crimson_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="about_crimson_content">
                        <h2>关于Crimson</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Crimson Interactive成立于2005年，是一家被公认为研究和出版解决方案的全球领导者的跨国公司，也是研究人员、出版商、大学和企业信赖的合作伙伴，已协助来自125个国家超过两百万名科研作者。Crimson的客户包括顶级大学，如麻省理工学院、普林斯顿大学、哥伦比亚大学和牛津大学等，以及丰田、威利、爱思唯尔、凯捷、松下、富士通、吉尼斯世界纪录和日立等大型公司。</p>
                        <p>Crimson拥有众多成功品牌，包括英论阁（Enago）、优译堂（Ulatus）、Voxtab、Trinka.ai 和 Enago Life Sciences。Crimson的专业领域涵盖科学出版解决方案、电子学习、本地化、医疗通信、人工智能和媒体解决方案。它还是医疗保健和生物制药公司的全球医疗通信合作伙伴。Crimson在全球10个主要国际地点设有办事处，包括北京、东京、首尔、伊斯坦布尔、上海、伦敦、新泽西和纽约。</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about_crimson_img">
                        <img src="assets/images/aboutCrimson.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="crimson_brand_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="crimson_brand_content">
                        <h2>我们的品牌</h2>
                        <div class="HeadingSubLine"></div>
                        <ul>
                            <li>
                                <a href="https://www.enago.com/" class="enago_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/enago-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>语言编辑服务</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.ulatus.com/" class="ulatus_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/ulatus-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>翻译服务</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.voxtab.com/" class="voxtab_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/voxtab-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>转录服务</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://cloud.trinka.ai/signup?_rg=CN" class="trinka_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/trinka-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>语法纠正和写作助理 </p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://lifesciences.enago.com/" class="lifes_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/lifes-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>医学出版物</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="global_offices">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>我们的全球网点</h2>
                    <div class="HeadingSubLine"></div>
                    <p>我们在世界各地都设有分支机构，以更好地为学术界提供服务。</p>
                    <div class="global-presence-wrap mart-20">
                        <div class="global-maps" style="position: relative;">
                            <div class="row">
                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap usa marr-10" id="usa" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">New Jersey,<br/> USA</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap usa padb-20" id="usaview">
                                    <div class="row">
                                        <div class="col-md-12 col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>New Jersey, USA</h3>
                                                <p class="marb-10">
                                                    <br>&nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap korea marr-20" id="korea" onclick="viewlocation(id)">

                                    <div class="map-box"></div>
                                    <div class="location-name">Seoul, Korea </div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap korea padb-20" id="koreaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Seoul, Korea</h3>
                                            <p>Crimson Interactive Korea Co., Ltd.
                                                <br> #803-74, 1-Dong, 775, Gyeongin-ro, Yeongdeungpo-gu, Seoul, Republic of Korea
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap china marr-20 active" id="china" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Beijing / Shanghai, China</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap china padb-20 show" id="chinaview">
                                    <div class="row">
                                        <div class="col-md-6  col-sm-6  col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Beijing, China</h3>
                                                <p class="marb-10">Room 607, Attempt Center, No. A6 Zhongguancun South Street, Haidian District,
                                                    Beijing, China - 100086
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6  col-sm-6 col-xs-12  global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Shangai, China</h3>
                                                <p class="marb-10">Room 101, No. 110, Tianlinshiyicun, Xuhui District, Shanghai 200233
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap japan marr-20" id="japan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Tokyo, Japan</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap japan padb-20" id="japanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Tokyo, Japan</h3>
                                            <p class="marb-10">Crimson Interactive K.K.
                                                <br> 4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo, 101-0021,
                                                Japan
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap india" id="india" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Mumbai, India</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap india padb-20" id="indiaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Mumbai, India</h3>
                                            <p class="marb-10">Crimson Interactive
                                                <br> 1001, 10th Floor, Techniplex - II, Veer Savarkar Flyover, S. V. Road, Goregaon
                                                (W), Mumbai 400062, India
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap uk" id="uk" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">London, United Kingdom</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap uk padb-20" id="ukview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>London, United Kingdom</h3>
                                            <p class="marb-10">Woodberry House, 2 Woodberry Grove, Finchley, London, N12 0DR, United Kingdom
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap turkey" id="turkey" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Istanbul,
                                        <br />Turkey</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap turkey padb-20" id="turkeyview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Istanbul, Turkey</h3>
                                            <p class="marb-10">Levent Mah. Ulgen Sok. No:52 Besiktas Istanbul, TURKEY
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap taiwan" id="taiwan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Taipei,
                                        <br> Taiwan</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap taiwan padb-20" id="taiwanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Taipei, Taiwan</h3>
                                            <p class="marb-10">
                                                2F, No. 40, Ln 91, Sec.1,
                                                <br> Neihu Road, Neihu Dist., Taipei City 11441, Taiwan.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="no_of_glance_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="glance_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                        <h2>数据一览</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="glance_contents">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/Aboutus-author.png" alt="">
                                    </div>
                                    <p>两百万+作者</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/aboutus_satisfy.png" alt="">
                                    </div>
                                    <p>顾客满意度</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/aboutus_degree_cap.png" alt="">
                                    </div>
                                    <p>2000多名博士/硕士专家</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/globe.svg" alt="" style="width: 40px;">
                                    </div>
                                    <p>125多个国家/地区</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_us_our_client">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>我们的客户</h2>
                    <div class="HeadingSubLine"></div>
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#UniversityPartners" role="tab">大学合作伙伴</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#Corporates_sections" role="tab">公司</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="UniversityPartners" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="assets/images/client_logos/Columbia_Univ_207.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Duke_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Priceton_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Purdue_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/MIT.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Technical-University-of-Denmark.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Univ_of_Birmingham.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Yonsei_University.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/University_of_Gassgow.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Washinton_State_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Korea_University.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/KyotoUniversityLogo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Peking-University.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Tsinghua_University79.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/University_of_Tokyo.png" alt="">
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane" id="Corporates_sections" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="assets/images/Corporates_logos/wiley-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/IBMWatson-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/bombay-stock.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/Netflix-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/toyota_log.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/guiness_world_Recodos.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/oup.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/Johnson-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/sony_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/bankofjapan.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/abbott.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/FujiTsu_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/DowJones-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/canon_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/pfizer-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/sanofi_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/RBS_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/iifl-logo.png" alt="">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="awards_certifications">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>获奖及认证</h2>
                    <div class="HeadingSubLine"></div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/golden-bridge-medal.png" alt="">
                                    </div>
                                    <p>The Golden Bridge Awards For Best Entrepreneur (Women)</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/pharma-award.png" alt="">
                                    </div>
                                    <p>APAC CIO Outlook Top 10 Pharma & Life Science Tech Solution Providers</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/ksci.png" alt="">
                                    </div>
                                    <p>Korea
                                        <br /> Satisfaction Consumer
                                        <br /> Index
                                    </p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/bizz-award.png" alt="">
                                    </div>
                                    <p>Bizz Award For Business Excellence</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/qms-award.png" alt="">
                                    </div>
                                    <p>The World Quality
                                        <br /> Commitment Award</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/red-awards.png" alt="">
                                    </div>
                                    <p>Red Herring Top 100 Asia
                                        <br /> and Global Awards!</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/sme-award.png" alt="">
                                    </div>
                                    <p>Google SME Award</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="our_values_slider">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>我们的价值</h2>
                    <div class="HeadingSubLine"></div>
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>社会责任</h4>
                                <p>我们相信，通过道德和透明的行为，我们能够对社会和环境产生积极影响，推动社会的可持续发展。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>尊重</h4>
                                <p>在与文化、人和环境打交道时，我们践行尊重的价值观。对学习者和老师的尊重体现在我们坚定不移地努力实现他们的期望，我们也坚持在不同的文化背景下践行礼貌、耐心和敏感的美德。</p>
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Wow</h4>
                                <p>“Wow”是我们价值体系的核心，这意味着要以超出所有期望的方式交付我们的工作。我们坚持不懈地努力通过改善沟通和提供创新的学习体验来实现“Wow”。
                                </p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>精益求精</h4>
                                <p>精益求精的价值观意味着我们坚持持续改进，它构成了我们所有教学的核心。改善的本质是创新，我们将技术和人力作为创新的关键驱动力实现持续的改善。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>创新</h4>
                                <p>我们相信，在提高学习者学习能力的同时，我们可以实现对既有实践的创新体验，增进我们的任务目标。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>简单</h4>
                                <p>简单意味着我们专注于通过尖端技术支持的简单流程，以最有效的方式提供卓越的服务质量。这体现在我们易于使用的用户界面、易于浏览的网站、明确的服务条款和条件，以及个性化的服务。</p>
                            </div>
                        </div>

                    </div>
                    <div class="slider_background_shadow"></div>

                </div>
            </div>
        </div>
    </div>

    <div class="about_us_footer_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="footer_sections_abouts">
                        <p>您是否想投入自己的原创思维和专业知识，加入快速发展的自然语言处理世界？如果您的回答是“是”，那让我们携手并进，一起攀登新的高度！</p>
                        <a href="https://trinka.enago.cn/workwithus/" target="_blank">加入我们</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>